module.exports = __webpack_public_path__ + "img/b_KalsiyForte_front_3.bbec3625.jpeg";